import React from 'react';
import HeaderWithoutLang from '../HeaderWithoutLang';
import Footer from '../Footer';
import AnchorHeroSection from './AnchorHeroSection';
import AnchorAboutSection from './AnchorAboutSection';
import usePageTitle from '../../hooks/usePageTitle';
const AnchorLandingPage = () => {
    usePageTitle('Register to unlock Credit for your Supplier - GrowBizh ');
    return (
        <>
            <HeaderWithoutLang />
            <AnchorHeroSection />
            <AnchorAboutSection />
            <Footer />
        </>
    );
};

export default AnchorLandingPage;

